module.exports = __webpack_public_path__ + "img/train-4.2e37597e.jpg";